import { AnchoredPanel, BookmarkablePage, useNavigation } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { ConsoleContext } from "../../console/ConsoleContext";
import { MYSQL_LIST_ROUTE, PageId, PageRegistrationConfig } from "../../constants/pluginConstants";
import { MysqlList } from "./MysqlList";

const registrationIds = PageRegistrationConfig[PageId.MYSQL_LIST].map(config => config.key);

export const MysqlListPage = (): JSX.Element => {
  const { back, navigateToSelf } = useNavigation(ConsoleContext);

  React.useEffect(() => {
    // In case page was navigated to directly by entring its URL in the browser
    navigateToSelf(MYSQL_LIST_ROUTE, registrationIds[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BookmarkablePage
      appContext={ConsoleContext}
      registrationIds={registrationIds}
      title={Messages.listMysql.titles.short()}
    >
      <AnchoredPanel
        anchorId="page"
        title={Messages.listMysql.titles.long()}
        icon="mysql-svg"
        onClose={back}
        isOpen
      >
        <MysqlList />
      </AnchoredPanel>
    </BookmarkablePage>
  );
};
